"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /**
                     * Copyright 2013-present, Novivia, Inc.
                     * All rights reserved.
                     */

var _Button = require("react-bootstrap/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require("react-fa/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Button that allow to watch either an auction or a lot.
 * @class
 */
var WatchButton = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(WatchButton, _Component);

  function WatchButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, WatchButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WatchButton.__proto__ || (0, _getPrototypeOf2.default)(WatchButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // FIXME: Trigger a modal when there's an error.
      watchErrors: null,

      watched: _this.props.watched || _this.isWatched(_this.props.type)
    }, _this.onChange = function () {
      if (_this.props.onChange) {
        _this.props.onChange(_this.state.watched);
      }
    }, _this.handleClick = function () {
      if (!_this.props.disabled) {
        var setWatch = null;
        var toSet = null;

        if (_this.props.type === "auction") {
          setWatch = _this.state.watched ? _this.props.actions.auction.unwatch : _this.props.actions.auction.watch;

          toSet = {
            auctionId: _this.props.auctionId
          };
        } else if (_this.props.type === "lot") {
          setWatch = _this.state.watched ? _this.props.actions.lot.unwatch : _this.props.actions.lot.watch;
          toSet = {
            lotId: _this.props.lotId
          };
        }

        if (setWatch && toSet) {
          setWatch(toSet, function (err) {
            if (!err) {
              return _this.setState(function (state) {
                return { watched: !state.watched };
              }, _this.onChange);
            }

            _this.setState({
              watchErrors: err || null
            });
          });
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(WatchButton, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.type !== this.props.type || this.props.watchedLots && nextProps.watchedLots.length !== this.props.watchedLots.length || this.props.watchedAuctions && nextProps.watchedAuctions.length !== this.props.watchedAuctions.length) {
        this.setState({
          watched: this.isWatched(nextProps.type)
        });
      }
    }
  }, {
    key: "isWatched",
    value: function isWatched(type) {
      var listWatched = void 0;
      var watchedId = void 0;
      if (type === "auction") {
        listWatched = this.props.watchedAuctions;
        watchedId = this.props.auctionId;
      } else {
        listWatched = this.props.watchedLots;
        watchedId = this.props.lotId;
      }

      return listWatched && ~listWatched.indexOf(watchedId);
    }
  }, {
    key: "render",
    value: function render() {
      var __ = this.context.__;


      var buttonText = this.props.type === "auction" ? __("auction::catalog.watchThisAuction") : __("auction::catalog.watchThisLot");
      var buttonIcon = _react2.default.createElement(_Icon2.default, { name: "eye" });

      if (this.state.watched) {
        buttonIcon = _react2.default.createElement(_Icon2.default, { name: "eye-slash" });
        buttonText = this.props.type === "auction" ? __("auction::catalog.unwatchThisAuction") : __("auction::catalog.unwatchThisLot");
      }

      return _react2.default.createElement(
        _Button2.default,
        {
          bsSize: "xsmall",
          bsStyle: "default",
          disabled: this.props.disabled,
          onClick: this.handleClick
        },
        buttonIcon,
        " ",
        buttonText
      );
    }
  }]);
  return WatchButton;
}(_react.Component), _class.propTypes = {
  // Auction on the lot or auction watch button.
  actions: _propTypes2.default.object.isRequired,

  // Id of the auction to watch.
  auctionId: _propTypes2.default.string,

  // The watch button is disabled.
  disabled: _propTypes2.default.bool,

  // Id of the lot to watch
  lotId: _propTypes2.default.string,

  // Amount to display.
  type: _propTypes2.default.oneOf(["auction", "lot"]).isRequired,

  // Whether the thing to watch is initially watched.
  watched: _propTypes2.default.bool,

  // List of watched auctions id of user.
  watchedAuctions: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // List of watched lots id of user.
  watchedLots: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Event fired when the entity is watched/unwatched.
  onChange: _propTypes2.default.func
}, _class.defaultProps = {
  disabled: false
}, _class.contextTypes = {
  // Translation utility.
  __: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = WatchButton;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/WatchButton.jsx
// module id = 410
// module chunks = 15 18 19